var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoJobFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 445,
    height: 402,
    viewBox: "0 0 445 402",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.867 402L161.597 381.039L189.729 32.515L445 53.4764L416.867 402Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.807 397.025L165.413 376.622L192.79 37.4904L441.184 57.888L413.807 397.025Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.488 343.397L176.972 392.128L111.572 48.7308L363.088 0L428.488 343.397Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.218 339.429L179.48 386.849L115.842 52.6985L360.581 5.28342L424.218 339.429Z",
    fill: "#FF0990"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.088 25.9368H141.973V375.614H398.088V25.9368Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.641 30.646H145.424V370.9H394.641V30.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.406 89.3536C229.677 112.121 248.201 130.358 270.776 130.076C293.351 129.794 311.442 111.119 311.161 88.346C311.073 79.8824 308.386 71.6509 303.466 64.7685C298.546 57.8861 291.631 52.6861 283.659 49.8741L283.784 60.4932C283.84 64.1855 282.432 67.7495 279.868 70.4044C277.305 73.0592 273.796 74.5885 270.108 74.6571C266.427 74.6781 262.887 73.239 260.262 70.6545C257.637 68.0699 256.141 64.55 256.099 60.8638L255.974 50.2448C248.074 53.2473 241.288 58.6103 236.535 65.6063C231.782 72.6024 229.293 80.893 229.406 89.3536Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.176 85.0151C311.176 62.2421 292.877 43.771 270.296 43.771C247.716 43.771 229.416 62.2317 229.416 85.0151C229.401 93.4801 231.988 101.745 236.825 108.687C241.662 115.629 248.515 120.913 256.454 123.821V113.202C256.451 109.516 257.906 105.978 260.499 103.363C263.093 100.747 266.615 99.2652 270.296 99.2418C273.977 99.2652 277.5 100.747 280.093 103.363C282.687 105.978 284.141 109.516 284.138 113.202V123.826C292.078 120.918 298.932 115.633 303.769 108.69C308.606 101.747 311.192 93.481 311.176 85.0151Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.322 95.1957C279.001 95.1957 286.036 88.0993 286.036 79.3454C286.036 70.5915 279.001 63.4951 270.322 63.4951C261.644 63.4951 254.608 70.5915 254.608 79.3454C254.608 88.0993 261.644 95.1957 270.322 95.1957Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.296 99.2418C266.615 99.2652 263.093 100.747 260.499 103.363C257.905 105.978 256.451 109.516 256.454 113.202V123.826C265.399 127.061 275.193 127.061 284.138 123.826V113.202C284.141 109.516 282.687 105.978 280.093 103.363C277.499 100.747 273.977 99.2652 270.296 99.2418Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.473 78.4683C253.211 76.0037 252.633 73.2451 252.799 70.4805C252.978 67.7088 254.227 65.1155 256.282 63.2497C258.57 61.2815 261.673 60.5871 264.67 60.347C267.668 60.1068 270.708 60.253 273.659 59.6631C276.102 59.1614 278.42 58.1773 280.479 56.7681C282.538 55.359 284.296 53.5531 285.65 51.456C285.838 53.7792 286.025 56.1547 285.582 58.431C285.139 60.7072 283.971 62.973 282.001 64.1738C284.388 63.0618 284.128 65.6722 283.612 67.2332C284.795 68.6741 287.668 68.9143 287.814 70.7781C287.96 72.6419 287.934 74.5684 287.214 76.286C286.495 78.0037 287.266 81.0369 285.421 81.1674",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.473 78.4683C253.211 76.0037 252.633 73.2451 252.799 70.4805C252.978 67.7088 254.227 65.1155 256.282 63.2497C258.57 61.2815 261.673 60.5871 264.67 60.347C267.668 60.1068 270.708 60.253 273.659 59.6631C276.102 59.1614 278.42 58.1773 280.479 56.7681C282.538 55.359 284.296 53.5531 285.65 51.456C285.838 53.7792 286.025 56.1547 285.582 58.431C285.139 60.7072 283.971 62.973 282.001 64.1738C284.388 63.0618 284.128 65.6722 283.612 67.2332C284.795 68.6741 287.668 68.9143 287.814 70.7781C287.96 72.6419 287.934 74.5684 287.214 76.286C286.495 78.0037 287.266 81.0369 285.421 81.1674",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.876 63.8292C282.876 63.8292 293.825 64.7951 286.036 81.2092L282.876 63.8292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.623 299.673H168.771V333.817H202.623V299.673Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.698 302.617H171.685V330.872H199.698V302.617Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.698 229H171.685V257.255H199.698V229Z",
    fill: "#FF4694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.698 156H171.685V184.255H199.698V156Z",
    fill: "#63525A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.176 158.388H229.468V164.277H311.176V158.388Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.207 166.632H229.468V172.521H367.207V166.632Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.207 174.87H229.468V180.759H367.207V174.87Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.176 231.975H229.468V237.864H311.176V231.975Z",
    fill: "#FF0990"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.207 240.213H229.468V246.102H367.207V240.213Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.207 248.457H229.468V254.346H367.207V248.457Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.176 305.557H229.468V311.446H311.176V305.557Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.207 313.8H229.468V319.689H367.207V313.8Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.207 322.044H229.468V327.933H367.207V322.044Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.071 263.477H102C100.06 236.809 78.0169 215.775 51.078 215.775C22.867 215.775 -0.015625 238.84 -0.015625 267.293C-0.015625 295.747 22.8514 318.812 51.078 318.812C75.8324 318.812 96.468 301.061 101.129 277.469H121.05C122.903 277.469 124.68 276.732 125.99 275.42C127.301 274.108 128.037 272.328 128.037 270.473C128.037 268.617 127.301 266.838 125.99 265.526C124.68 264.214 122.903 263.477 121.05 263.477H121.071Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0376 219.612C25.9276 219.612 4.76025 240.96 4.76025 267.293C4.76025 293.627 25.9276 314.975 52.0376 314.975C78.1475 314.975 99.3149 293.627 99.3149 267.293C99.3149 240.96 78.1475 219.612 52.0376 219.612ZM52.0376 307.916C29.7962 307.916 11.7674 289.732 11.7674 267.299C11.7674 244.865 29.7962 226.681 52.0376 226.681C74.2789 226.681 92.3077 244.855 92.3077 267.304C92.3077 289.753 74.2789 307.911 52.0376 307.911V307.916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2324 263.764H117.51C119.031 263.764 120.49 264.369 121.566 265.446C122.641 266.523 123.245 267.984 123.245 269.507V270.958C123.245 272.482 122.641 273.942 121.566 275.019C120.49 276.096 119.031 276.701 117.51 276.701H95.2324V263.764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0426 308.501C74.6057 308.501 92.8967 290.052 92.8967 267.293C92.8967 244.535 74.6057 226.086 52.0426 226.086C29.4795 226.086 11.1885 244.535 11.1885 267.293C11.1885 290.052 29.4795 308.501 52.0426 308.501Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M56.6043 251.929C53.4188 253.599 51.8808 258.194 53.9975 261.128C54.8421 262.292 56.083 263.065 57.1622 264.025C58.2414 264.986 59.1538 266.328 58.9661 267.758C58.7823 268.63 58.3784 269.441 57.793 270.113C55.6502 272.953 53.0069 275.652 52.3135 279.15C51.6879 282.324 52.8349 285.644 54.7014 288.281C55.7441 289.779 57.1466 291.168 58.914 291.648C60.8691 292.17 62.9858 291.481 64.649 290.286C66.3121 289.09 67.5373 287.44 68.7573 285.817L71.5988 282.037C72.3756 280.993 73.1629 279.881 73.2463 278.586C73.3453 276.362 71.2651 274.696 70.556 272.593C69.2422 268.687 72.8657 264.652 72.3808 260.553C71.6353 254.362 62.0943 249.031 56.6043 251.929Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 289.164,
    y1: 391.555,
    x2: 317.561,
    y2: 42.9043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 132792,
    y1: 251605,
    x2: 132792,
    y2: 17397.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 272.888,
    y1: 129.41,
    x2: 268.71,
    y2: 48.9294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 12225.9,
    y1: 22131.3,
    x2: 12225.9,
    y2: 19898.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 37903.4,
    y1: 69833.9,
    x2: 37903.4,
    y2: 49498.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 445,
    height: 402,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoJobFound);
export default __webpack_public_path__ + "static/media/no-job-found.43238309.svg";
export { ForwardRef as ReactComponent };